module.exports = __webpack_public_path__ + "img/frame3.3068794d.jpg";